import { readable } from 'svelte/store';
import { router } from 'svelte-spa-router';

/** Readable path store — svelte-spa-router v5 replaced the old `location` export with `router.location`. */
export const location = readable(router.location, (set) => {
  if (typeof window === 'undefined') return;
  const sync = () => set(router.location);
  window.addEventListener('hashchange', sync);
  sync();
  return () => window.removeEventListener('hashchange', sync);
});
